import React from "react";
import Project from "../components/project-wrapper";
import GrammarParsing from "../images/parsing-img.png";
import TreeAVL from "../images/treeAVL-img.png";
import KnockiApp from "../images/knocki-img.png";
import GunnedDown from "../images/videogame-img.png";
import ALVAP from "../images/alvap-img.png";
import Hack2020 from "../images/hack2020-img.png";

const projectsList = [
  {
    id: "alvap",
    languages: ["react", "typescript", "sqlite"],
    link: "https://github.com/MarioJim/alvap-store",
    image: ALVAP,
    title: "ALVAP Store",
    description:
      "Store prototype with a database implemented. Developed with React and Typescript (Frontend) and SQLite (Backend)",
  },
  {
    id: "videogame",
    languages: ["unity", "c#"],
    link: "https://github.com/KevinTMtz/GunnedDown",
    image: GunnedDown,
    title: "Gunned Down",
    description:
      "Roguelike videogame with multiple playable characters and enemies. Developed in Unity and functionality with C#",
  },
  {
    id: "hack2020",
    languages: ["react", "typescript", "firebase"],
    link:
      "https://github.com/KevinTMtz/HackMTY2020/tree/master/blue-yonder-front",
    image: Hack2020,
    title: "HackMTY 2020 project",
    description:
      "An app that optimizes room space for the furniture with safe-space in mind. Developed with React and Typescript (Frontend) and Firebase (Backend)",
  },
  {
    id: "knocki",
    languages: ["html5", "css3", "jQuery"],
    link: "https://github.com/SebasRod23/Knocki-website-app-",
    image: KnockiApp,
    title: "Protype-App and Website for Knocki",
    description:
      "Website and high-level proto-app for startup project, Knocki. Developed with HTML5 & CSS3(design), and JQuery (functionality)",
  },
  {
    id: "parsing",
    languages: ["python", "tkinter"],
    link: "https://github.com/SebasRod23/Grammar-Parsing",
    image: GrammarParsing,
    title: "Grammar-Parsing tree",
    description:
      "Parsing tree representation of a context-free grammar. Developed in Python, using tkinter",
  },
  {
    id: "tree",
    languages: ["java", "javaFx"],
    link: "https://github.com/SebasRod23/Tree-AVL",
    image: TreeAVL,
    title: "AVL tree",
    description:
      "Graphical representation of an AVL tree, with animations for the process of balancing. Developed in Java, using JavaFx",
  },
];
function projects() {
  return (
    <div id="projects">
      {projectsList.map(
        ({ id, languages, link, image, title, description }) => (
          <Project
            id={id}
            languages={languages}
            link={link}
            image={image}
            title={title}
            description={description}
          ></Project>
        )
      )}
    </div>
  );
}

export default projects;
